
























import Vue from "vue";
import iwAccordion from "@/encoding/components/Accordion.vue";
import iwInputCheckboxGroup from "@/encoding/components/buildingBlocks/InputCheckboxGroup.vue";
import iwFloorAreaCellar from "./FloorAreaCellar.vue";

export default Vue.extend({
    components: {
        iwAccordion: iwAccordion,
        iwInputCheckboxGroup: iwInputCheckboxGroup,
        iwFloorAreaCellar: iwFloorAreaCellar
    },
    data: function() {
        return {
            pathInStoreExists: "property.basement.exists",
            pathInStoreFloorAreaCellar: "property.basement.surface",
            checkboxes: [
                {
                    value: "hasCellar",
                    label: "is_there_a_cellar"
                }
            ]
        };
    },
    computed: {
        isDisplayed: function(): boolean {
            return ["HOUSE", "APARTMENT", "COMMERCIAL", "OFFICE", "INDUSTRY", "OTHER"].indexOf(this.getPropertyType()) !== - 1;
        },
        valueChecked: function(): Array<string> | void {
            if (this.$store.getters["FormModule/getValue"](this.pathInStoreExists)) {
                return ["hasCellar"];
            }
        },
        getErrorMessage: function(): string|null {
            return this.$store.getters["FormModule/getErrorObjectByPath"](this.pathInStoreExists) || this.$store.getters["FormModule/getErrorObjectByPath"](this.pathInStoreFloorAreaCellar);
        },
        isOpen: function(): boolean {
            let isOpen = false;

            if(this.valueChecked && this.valueChecked.length > 0) {
                isOpen = true;
            }
            return isOpen;
        },
        floorAreaCellarInput: function(): Vue | void {
            const accordionComponent = this.$refs.floorAreaCellar as Vue;
            if(accordionComponent !== null) {
                const accordionInput = accordionComponent.$refs.floorAreaCellarInput as Vue;
                if(accordionInput !== null) {
                    return accordionInput;
                }
            }
        }
    },
    mounted: function() {
        if (this.$store.getters["FormModule/getValue"](this.pathInStoreExists) == null && this.isDisplayed) {
            this.$store.dispatch("FormModule/addValue", {path: this.pathInStoreExists, value: false});
        }
    },
    methods: {
        updateValueFloorAreaCellar: function(floorAreaCellar: number): void {
            if (floorAreaCellar == 0 && this.$store.getters["FormModule/getValue"](this.pathInStoreFloorAreaCellar) != null) {
                this.$store.commit("FormModule/deleteValue", this.pathInStoreFloorAreaCellar);
            } else {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStoreFloorAreaCellar, "value": floorAreaCellar});
            }
        },
        updateValue: function(selectedValues:  Array<string>): void {
            if(selectedValues.length > 0) {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStoreExists, "value": true});
            } else {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStoreExists, "value": false});
                if(this.floorAreaCellarInput) {
                    this.floorAreaCellarInput.$data.internalInput = 0;
                }
                this.$store.commit("FormModule/deleteValue", this.pathInStoreFloorAreaCellar);
            }
        }
    },
});
